<template>
    <CreateEventGrid/>
  </template>
  
  <script>
  import CreateEventGrid from './CreateEventGrid'
  export default {
    components: {
      CreateEventGrid
    },
    data () {
      return {
  
      }
    },
    created () {
      this.$store.commit('updateTitle', 'Administrar Eventos')
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/CreateEvent.vue